let api

if (process.env.NODE_ENV === "development") {
    api = "http://localhost:5010/api"
} else {
    // api = "https://backend-swagruhafoods.nbjfit.easypanel.host/api" // staging
    api = "https://backend.swagruhafoods.net/api" // production
}

export default api
